import { NEW_API_ROUTE_ADMIN_DRILL_DOWN_COST_OBJECT_PRODUCTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { DrillDownParamsOriginal, EntityOriginal, ListResponse } from './types'

import type { ReportEntityWithQuantity } from '../../drilldown/types'

type ProductByCostObject = ReportEntityWithQuantity & {
  productCategoryId: number
  productCategoryName: string
  productGroupId: number
  productGroupName: string
  productId: number
  productName: string
}

type DDProductByCostObjectResponse = ListResponse<ProductByCostObject> & {
  costObject: EntityOriginal
}

export const getDrillDownProductByCostObjectsReport = async (params: DrillDownParamsOriginal) => {
  const query = new URLSearchParams({ ...params })

  const IS_NEW_BACKEND_API = true

  const categoryResult = await get<DDProductByCostObjectResponse>(
    `${NEW_API_ROUTE_ADMIN_DRILL_DOWN_COST_OBJECT_PRODUCTS}?${query.toString()}`,
    IS_NEW_BACKEND_API
  )

  return {
    ...categoryResult,
    rows: categoryResult.rows.map(category => ({
      ...category,
      amount: Number(category.amount),
      salaryDeductionAmount: Number(category.salaryDeductionAmount),
    })),
  }
}
